import * as angular from 'angular';
import 'datatables.net';
import 'datatables.net-fixedheader';
import * as dayjs from 'dayjs';
import * as isLeapYear from 'dayjs/plugin/isLeapYear';
import 'foundation-sites';

import { AppController } from './core/controllers/app-controller';
import { SessionController } from './core/controllers/session-controller';
import { VideoController } from './core/controllers/video-controller';
import { HttpInterceptorFactory } from './core/interceptors/http-interceptor';
import { combineReducers, enhancers, INgReduxProvider, middleware } from './core/redux';
import { AccountService } from './core/services/account-service';
import { AppService } from './core/services/app-service';
import { BeforeUnloadService } from './core/services/before-unload-service';
import { BrowserService } from './core/services/browser-service';
import { DemoService } from './core/services/demo-service';
import { ModalService } from './core/services/modal-service';
import { VideoService } from './core/services/video-service';
import { reducers as appReducers } from './core/store';
import { AppActions } from './core/store/app-actions';
import { SessionActions } from './core/store/session-actions';
import './shared';

// Add the leap year plugin
dayjs.extend(isLeapYear);

export const app = {
    init: (reducers: any = {}, ...requires: string[]) => {
        // Bootstrap the app module
        const module = angular.module('fcApp', [
            'chart.js',
            'angularResizable',
            'ngMessages',
            'ngMaterial',
            'ngRedux',
            'fcShared',
            ...requires
        ]);

        // Add any app level controller, directives, etc.
        module
            .filter('unsafe', ['$sce', $sce => (val: any) => $sce.trustAsHtml(val)])
            .service('fcAppActions', AppActions)
            .service('fcSessionActions', SessionActions)
            .service('fcAppService', AppService)
            .service('fcBeforeUnloadService', BeforeUnloadService)
            .service('fcBrowserService', BrowserService)
            .service('fcVideoService', VideoService)
            .service('fcModalService', ModalService)
            .service('fcDemoService', DemoService)
            .service('fcAccountService', AccountService)
            .controller('fcAppController', AppController)
            .controller('fcSessionController', SessionController)
            .controller('fcVideoController', VideoController);

        // Configure ng-redux
        module.config([
            '$ngReduxProvider',
            (ngReduxProvider: INgReduxProvider) => {
                // Setup redux with app and view levels
                const reducer = combineReducers({
                    ...appReducers,
                    ...reducers
                });

                ngReduxProvider.createStoreWith(reducer, middleware, enhancers);
            }
        ]);

        // Configure the http interceptor
        module.config([
            '$httpProvider',
            (httpProvider: angular.IHttpProvider) => {
                // Add the core http interceptor
                httpProvider.interceptors.push(HttpInterceptorFactory);

                // Add caching config - mainly to disble for IE
                httpProvider.defaults.headers.get = httpProvider.defaults.headers.get || {};

                // tslint:disable-next-line: no-string-literal
                httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
                httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                httpProvider.defaults.headers.get['If-Modified-Since'] =
                    'Mon, 26 Jul 1997 05:00:00 GMT';
            }
        ]);

        // Bootstrap the app
        angular.element(document).ready(() => {
            angular.bootstrap(document, ['fcApp']);

            // Remove the initializing class to resume normal styling
            angular.element('body').removeClass('fc-initializing');

            // Initialize foundation
            angular.element(document).foundation();
        });

        return module;
    }
};
